module.exports = __webpack_public_path__ + "static/img/斧.fd66bf2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wuqi/斧.png
// module id = SRiK
// module chunks = 4